import $ from 'jquery'

$(window).on('load resize', () => {
    const $quick_links = $('.hero-quick-links-container, .quick-links2-container')
    if($(window).width() <= 480) {
    $quick_links.css('width', '')
    const width = $quick_links.map((i, el) => $(el).outerWidth())
    const maxWidth = Math.max.apply(null, width)
    $quick_links.css('width', maxWidth)
    } else {
        $quick_links.css('width', 'fit-content')
    }
})